'use client';

import { type ReactNode, useMemo, useState } from 'react';
import type { RECORD_TYPE } from '@/entities/cmo-record/model/types';
import { createSafeContext } from '@/shared/utils/create-safe-context';

interface CMORecordsContextValue {
  uploadedFile: File | null;
  setUploadedFile: (file: File | null) => void;
  recordType: keyof typeof RECORD_TYPE | null;
  setRecordType: (type: keyof typeof RECORD_TYPE | null) => void;
}

const [CMORecordsContextProvider, useCMORecords] =
  createSafeContext<CMORecordsContextValue>('CMORecordsContext');

export { useCMORecords };

export function CMORecordsProvider({ children }: { children: ReactNode }) {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [recordType, setRecordType] = useState<keyof typeof RECORD_TYPE | null>(null);

  const value = useMemo(
    () => ({
      uploadedFile,
      setUploadedFile,
      recordType,
      setRecordType,
    }),
    [uploadedFile, recordType]
  );

  return <CMORecordsContextProvider value={value}>{children}</CMORecordsContextProvider>;
}
